import { render, staticRenderFns } from "./MarketingTaskController.vue?vue&type=template&id=103f27a4"
import script from "./MarketingTaskController.vue?vue&type=script&lang=js"
export * from "./MarketingTaskController.vue?vue&type=script&lang=js"
import style0 from "./MarketingTaskController.vue?vue&type=style&index=0&id=103f27a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports